import React from 'react';
import icon from 'shared/assets/icons/input-attention.svg';
import './FormFailedIconMessage.scss';

interface FormFailedIconMessageProps {
  isActive?: boolean;
  message?: string;
}

export const FormFailedIconMessage: React.FC<FormFailedIconMessageProps> = ({
  isActive = false,
  message,
}): JSX.Element => {
  if (!isActive) return <></>;

  return (
    <div className="form-failed-icon-message">
      <img
        className="form-failed-icon-message__icon"
        src={icon}
        alt={message}
      />
      <p className="form-failed-icon-message__message">{message}</p>
    </div>
  );
};
